// extracted by mini-css-extract-plugin
export default {"input":"styles_input__ODgF0","error":"styles_error__X1qmN"};